import React, { useEffect, useRef, useState } from "react";
import '../css/countdown.css';
import { useLanguage } from "../providers/preferenceProvider";

const CountdownTimer = ({ duration = 8, onExpire }) => {
  const [countdown, setCountdown] = useState(duration);
  const timerRef = useRef(null);
  const { t } = useLanguage();

  useEffect(() => {
    timerRef.current = setInterval(() => {
      setCountdown((prev) => {
        if (prev <= 1) {
          clearInterval(timerRef.current);
          timerRef.current = null;
          setTimeout(() => onExpire?.(), 0);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => {
      if (timerRef.current) {
        clearInterval(timerRef.current);
      }
    };
  }, [onExpire]);

  // Determine which class to use
  const className =
    countdown <= 5 ? "countdown-timer warning" : "countdown-timer default";

  return (
    <div
      className={`${className} cursor-pointer`}
      onClick={() => {
        if (timerRef.current) {
          clearInterval(timerRef.current);
          timerRef.current = null;
          setCountdown(0);
          onExpire?.();
        }
      }}
    >
      {t.display.closingIn} {countdown} {t.display.second}{countdown !== 1 ? t.display.secondPlural : ""}
    </div>
  );
};

export default CountdownTimer;
